<div>
    <octo-uber-connect [page]="'my-account'"></octo-uber-connect>
</div>
